import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up
import { MortalityModel } from 'src/app/models/MortalityModel';
import { MortalityService } from 'src/app/services/MortalityService';


@Component({
  selector: 'app-mortality',
  templateUrl: './mortality.component.html',
  styleUrls: ['./mortality.component.css']
})
export class MortalityComponent implements OnInit {
  mortalitypatientcode = '' ;
  mortalitydeath = '' ;
  mortalidate = '' ;
  mortalityreason = '' ;
  mortalitynotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public mortalityservice : MortalityService,
              public mortality : MortalityModel,
              public storage: LocalStorageService,
              public dialogRef: MatDialogRef<MortalityComponent>,
              @Inject(MAT_DIALOG_DATA)public data: any)
              {
                this.mortalitypatientcode = data.mortalitypatientcode,
                this.mortalitydeath = data.mortalitydeath ,
                this.mortalityreason = data.mortalityreason,
                this.mortalidate =formatDate( data.mortalidate, 'yyyy-MM-dd', 'en'),
                this.mortalitynotes = data.mortalitynotes
              }

  ngOnInit(): void {

  }


  submitmortality(){
    this.mortality.mortalitypatientcode = this.mortalitypatientcode;
    this.mortality.mortalitydeath = this.mortalitydeath;

    this.mortality.mortalidate = formatDate( this.mortalidate, 'yyyy-MM-dd', 'en');
    this.mortality.mortalityreason = this.mortalityreason;
    this.mortality.mortalitynotes = this.mortalitynotes;


    this.mortality.userid = this.userid;
    this.mortality.compcode =  this.storage.retrieve('stgcompCode');
    this.mortality.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');



  this.mortalityservice.AddMortality(this.mortality).subscribe(data => {

    this.messagesave();
    this.dialogRef.close();
  },
    error => { alert(error); }
  );
  }
  DeleteMortal(){
    this.mortalityservice.DelMortality(this.mortalitypatientcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: MortalityModel) => {
        this.mortalitypatientcode = data.mortalitypatientcode;

      }
    );
    this.dialogRef.close();
  }
  messagesave(){
      Swal({title:'Saved',
            type:'success',
            showConfirmButton:false,
            timer:1500});
   }
  mesgDelete(){
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.DeleteMortal();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  CloseDialog(){
    this.dialogRef.close();
  }
}
